<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">TECNOLOGIA DIGITAL</h1>
      <div class="title-main">
        <p>A tecnologia é base para o que chamamos de transformação digital. E, naturalmente, falar em ferramentas digitais leva-nos à outras reflexões importantes como análise de dados, métricas, indicadores, segurança, tecnologias futuras, gestão da informação, entre outros aspectos.</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';
import rollDown from '../mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'tecnologia_digital',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/tecnologia-digital/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 4);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/test/DigitalTechnology.vue